import { FunctionComponent, useEffect, useState } from 'react'
import TypingAnimationWrapper from '@components/Chatbot/messages/TypingEffectWrapper'
import React from 'react'
import styled, { css } from 'styled-components'
import AnimatedStars from '@components/Chatbot/loading/AnimatedStars'
import translate from '@i18n'

const StyledAnswerLoaderWrapper = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: small2BodyCopy },
        },
      },
    },
  }) => css`
    display: flex;
    gap: 9px;
    min-height: 26px;
    & > span {
      ${small2BodyCopy}
    }
  `}
`

const AnswerLoader: FunctionComponent = () => {
  const [iteration, setIteration] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setIteration((i) => i + 1)
    }, 2500)
    return () => clearInterval(interval)
  }, [])

  return (
    <StyledAnswerLoaderWrapper>
      <AnimatedStars />
      <TypingAnimationWrapper
        key={iteration}
        text={translate('chatbot.answerMessage.loading')}
      />
    </StyledAnswerLoaderWrapper>
  )
}

export default AnswerLoader
